import { Button } from "ui/components/button";
import { Label } from "ui/components/label";
import useTableFilters from "@/hooks/useTableFilters";
import EvtMultiSelectBadges from "components/multiselect";
import SelectAny from "components/select/select-any";
import UserCombobox from "components/directus/combobox/user";
import { EMPLOYEE_FILTERS } from "components/employee/constants";

export default function OpeningsFilters({
    filters,
    setFilters,
    setIsOpen,
    isOpen,
    clearFilters,
    defaultFilters,
}) {
    const {
        localFilters,
        applyFilters,
        clearLocalFilters,
        setLocalFilters,
    } = useTableFilters({
        filters,
        setFilters,
        setIsOpen,
        clearFilters,
        initialFilters: {
            status: undefined,
            sales_coordinator: undefined,
            ...defaultFilters,
        },
    });

    return (
        <div className="w-full px-4 space-y-4">

            {/* sales coordinator */}
            <div>
                <Label className="mb-2 text-sm">Sales Coordinator</Label>
                <UserCombobox
                    value={localFilters.sales_coordinator?._eq}
                    onChange={(selectedItem) =>
                        setLocalFilters({
                            ...localFilters,
                            sales_coordinator: {
                                _eq: selectedItem,
                            },
                        })
                    }
                    filter={EMPLOYEE_FILTERS.sales_coordinating}
                    dependenton={isOpen}
                />
            </div>

            {/* skill Filter */}
            <div>
                <Label className="mb-2 text-sm">Skills</Label>
                <EvtMultiSelectBadges
                    collection="skills"
                    values={localFilters?.skills?.skill?._in || []}
                    onChange={(selectedItem) => {
                        setLocalFilters({
                            ...localFilters,
                            skills: selectedItem?.length ? { skill: { _in: selectedItem } } : undefined,
                        });
                    }}
                    placeholder="Select skills"
                />
            </div>

            {/* Status Filter */}
            <div>
                <Label className="mb-2 text-sm">Status</Label>
                <SelectAny
                    key={`status-filters`}
                    collection="openings"
                    field="status"
                    value={localFilters?.status?._eq}
                    onChange={(selectedItem) => {
                        setLocalFilters({
                            ...localFilters,
                            status: { _eq: selectedItem },
                        });
                    }}
                />
            </div>

            {/* Action Buttons */}
            <div className="flex place-self-end gap-4">
                <Button variant="outline" onClick={clearLocalFilters}>
                    Clear
                </Button>
                <Button onClick={() => applyFilters()}>Apply</Button>
            </div>
        </div>
    );
}
